import { FC } from "react";
import KickImage from 'Reuseables/KickImage';

//Interface
import { TimeslotCardInterface } from "../definitions";

const TimeslotCard: FC<TimeslotCardInterface> = ({ timeslotList, isActiveTimeHandler, timezone, selectTimeHandler }) => {
  if (!timeslotList?.length) return null;

  return (
    <>
      <p className="title">Set Pick-up Time</p>
      <div className="pickup-time-wrapper">
        {
          timeslotList.length && timeslotList.map((time, idx) => {
            const lastItem = (idx === timeslotList.length - 1) || (idx === timeslotList.length - 2) ? "lastitem" : "";
            const isActive = isActiveTimeHandler(time);
            return (
              <div key={idx} className={`time-card ${lastItem} ${isActive ? "active" : ""}`} onClick={() => selectTimeHandler(time)}>
                <p>
                  <span>{time.start_hour} {timezone}</span>
                  {" - "}
                  <span>{time.end_hour} {timezone}</span>
                </p>
              </div>
            )
          })
        }
      </div>
    </>
  )
}
export default TimeslotCard;